// src/context/AppContext.js
import React, { createContext, useContext, useState } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [pdfFiles, setPdfFiles] = useState([]);
  const [pdfPreviews, setPdfPreviews] = useState([]);
  const [details, setDetails] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [radioSelection, setRadioSelection] = useState('');
  const [stepFlow, setStepFlow] = useState([]);
  const [fileName, setFileName] = useState('');
  const [userEmail, setUserEmail] = useState('Eezeelearn@gmail.com');
  const [selectedLessons, setSelectedLessons] = useState([]);
  const [translatedLessons, setTranslatedLessons] = useState([]);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [audioURLs, setAudioURLs] = useState([]);

  return (
    <AppContext.Provider value={{
      pdfFiles,
      setPdfFiles,
      pdfPreviews,
      setPdfPreviews,
      details,
      setDetails,
      selectedOptions,
      setSelectedOptions,
      radioSelection,
      setRadioSelection,
      stepFlow,
      setStepFlow,
      fileName,
      setFileName,
      userEmail,
      setUserEmail,
      selectedLessons,
      setSelectedLessons,
      translatedLessons,
      setTranslatedLessons,
      completedSteps,
      setCompletedSteps,
      selectedLanguage,
      setSelectedLanguage,
      audioURLs,
      setAudioURLs
    }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
